import Box from '@mui/material/Box';
import CarViewer from '../components/CarViewer';

const CarsPage: React.FC = () => {
  return (
    <Box id="cars">
      <CarViewer url="/cars" />
    </Box>
  );
};

export default CarsPage;
